<template>
  <el-dialog
    :model-value="true"
    width="35em"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <span class="tc-text-class" v-html="$t('pages.app.messages.tc_and_pp_not_accepted_yet', { pp: transl_pp, tc: transl_tc })" />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="logout">{{ $t('pages.app.buttons.logout') }}</el-button>
        <el-button type="primary" @click="accept">{{ $t('pages.app.buttons.accept') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { acceptTC } from '@/api/v2/account'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useAccountStore } from '@/stores/account'

const { t } = useI18n()

const authStore = useAuthStore()
const accountStore = useAccountStore()

const emit = defineEmits<{
  hide: []
}>()

const transl_pp: string = t('pages.app.messages.privacy_policy')
const transl_tc: string = t('pages.app.messages.terms_and_conditions')

function accept() {
  acceptTC(true).then(() => {
    accountStore.getCurrentAccount(true).then(() => {
      emit('hide')
    })
  })
}

async function logout() {
  emit('hide')
  await authStore.logout()
}
</script>

<style lang="scss" scoped>

  .tc-text-class {
    word-break: normal;
  }
</style>
